import styled from "@emotion/styled";
import { FC } from "react";

import { Error } from "@livechat/design-system-icons";
import { Button, DesignToken, Heading, Icon, SpacingToken, Text } from "@livechat/design-system-react-components";

import Flex from "components/layout/Flex";
import { withVar } from "themes/helpers";

const Container = styled.div<{ isVisible: boolean }>`
  display: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => (props.isVisible ? "flex" : "none")
  };
  flex-direction: column;
  align-items: center;
  gap: var(${SpacingToken.Spacing4});
  padding-top: var(${SpacingToken.Spacing10});
`;

interface IProps {
  onCancel: () => void;
  onConfirm: () => void;
  isVisible: boolean;
}

export const ConfirmExitModalContent: FC<IProps> = ({ onCancel, onConfirm, isVisible }) => (
  <Container isVisible={isVisible}>
    <Flex
      column
      alignItems="center"
      paddingH={withVar(SpacingToken.Spacing9)}
      paddingBottom={withVar(SpacingToken.Spacing10)}
      gap={withVar(SpacingToken.Spacing3)}
      maxWidth="470px"
    >
      <Icon size="xxlarge" source={Error} customColor={withVar(DesignToken.ContentBasicDisabled)} />
      <Flex column alignItems="center" gap={withVar(SpacingToken.Spacing2)} css={{ textAlign: "center" }}>
        <Heading>Continue inviting new agents?</Heading>
        <Text>If you stop inviting agents now, they won&apos;t join the selected team role in HelpDesk.</Text>
      </Flex>
    </Flex>
    <Flex
      gap={withVar(SpacingToken.Spacing2)}
      width="100%"
      justifyContent="center"
      marginBottom={withVar(SpacingToken.Spacing9)}
    >
      <Button
        kind="secondary"
        size="large"
        onClick={onCancel}
        data-testid="invite-agent-close-modal-confirmation-button"
      >
        Cancel
      </Button>
      <Button size="large" onClick={onConfirm} kind="primary">
        Continue inviting
      </Button>
    </Flex>
  </Container>
);
